import { Head } from "@inertiajs/react"

import Navbar from "@/components/ttt/Navbar"
import Footer from "@/components/ttt/Footer"
import ItemDetail from "@/components/ttt/ItemDetail"
import type {
  TttChrome,
  TttItemAuthor,
  TttItemLabels,
} from "@/components/ttt/types"
import type {
  ItemDetailData,
  MediaItem,
  Variant,
} from "@/components/storefront/types"

interface Props {
  chrome: TttChrome
  item: ItemDetailData
  medias: MediaItem[]
  variants: Variant[]
  virtual_stock: number
  store: { holiday: boolean; display_stock: boolean }
  add_to_cart_url: string
  back: { url: string; label: string }
  labels: TttItemLabels
  authors: TttItemAuthor[]
  authors_active: boolean
}

export default function Item({
  chrome,
  item,
  medias,
  variants,
  virtual_stock,
  store,
  add_to_cart_url,
  back,
  labels,
  authors,
  authors_active,
}: Props) {
  return (
    <>
      <Head>
        <title>{`${item.name} — TTT`}</title>
      </Head>

      <Navbar chrome={chrome} />

      <ItemDetail
        item={item}
        medias={medias}
        variants={variants}
        virtualStock={virtual_stock}
        store={store}
        addToCartUrl={add_to_cart_url}
        back={back}
        labels={labels}
        authors={authors}
        authorsActive={authors_active}
        breadcrumb={[
          { label: "TTT", href: chrome.paths.root },
          { label: "Boutique", href: chrome.paths.store },
          { label: item.name },
        ]}
      />

      <Footer chrome={chrome} />
    </>
  )
}
